import { MedProductType } from "src/utils/constants";
import { registerHandler } from "../handler";
import { trackTask } from "src/utils/monitoring/events/tasks";
import uuid from "uuid";

declare const window: Window & {
  twq: any;
};

export default function registerHandlers() {
  registerHandler("purchaseIntent", ({ estimatedValue, medProductType }) => {
    if (window.twq && medProductType !== MedProductType.HRT) {
      const task = trackTask("trackTwitterPurchaseIntent");
      try {
        task.start();
        window.twq("event", "tw-ny4pj-oorxd", {
          value: estimatedValue,
          currency: "USD",
          conversion_id: uuid.v4(),
        });
        task.success();
      } catch (err) {
        task.failed(err);
      }
    }
  });
}
